'use client';
import { LocaleOption, localeOptions, switchLanguage } from '../../i18n/config';
import { useLocale } from 'use-intl';
// import { useI18nContext } from '../../i18n/I18nProvider';

interface LanguageSwitcherProps {
  bgColor?: string;
  textColor?: string;
  activeBgColor?: string;
  activeColor?: string;
  className?: string;
}

export default function LanguageSwitcher({
  bgColor = 'transparent',
  textColor = '#FFFFFF99',
  activeBgColor = '#1C3FF0',
  activeColor = '#FFFFFF',
  className = '',
}: LanguageSwitcherProps) {
  const locale = useLocale();
  // const { changeLocale } = useI18nContext();
  const handleSwitchDomain = (item: LocaleOption) => {
    const { value } = item;
    // https://test.ssv.tencent.com/case/activity/s-2025
    // https://en-test.ssv.tencent.com/case/activity/s-2025
    // https://ssv.tencent.com/case/activity/s-2025
    // https://en.ssv.tencent.com/case/activity/s-2025
    switchLanguage(value);
    // window.location.replace()
  };
  return (
    <div
      className={`inline-flex items-center ${className}`}
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      {localeOptions.map((item, index) => {
        const { value, label } = item;
        return (
          <div
            className="flex items-center text-base mobile:text-xs"
            key={value}
          >
            <div
              className="cursor-pointer"
              style={{
                color: value === locale ? activeColor : textColor,
              }}
              // onClick={() => changeLocale(value)}
              onClick={() => {
                handleSwitchDomain(item);
              }}
            >
              {label}
            </div>
            {index !== localeOptions.length - 1 && (
              <div className="mx-[10px]" style={{ color: textColor }}>
                |
              </div>
            )}
          </div>
        );
        // <div
        //   key={value}
        //   className={`w-20 h-11 leading-[44px] text-2xl border border-solid text-center cursor-pointer mobile:w-[32px] mobile:h-[21px] mobile:text-[11px] mobile:leading-[21px]`}
        //   style={{
        //     color: value === locale ? activeColor : textColor,
        //     backgroundColor: value === locale ? activeBgColor : bgColor,
        //     borderColor: activeBgColor,
        //   }}
        //   onClick={() => changeLocale(value)}
        // >
        //   {label}
        // </div>
      })}
    </div>
  );
}
